import type { HealthResponse } from '../api/types';

export interface SystemStatusView {
  label: string;
  color: string;
  /** Regel onder de status; null = geen regel. */
  sub: string | null;
}

/**
 * Wat de tegel "Status systeem" toont. "Optimaal" alleen op een health die
 * vers is en `ok` zegt. Is de laatste health-poll mislukt of te oud, dan
 * toont de tegel dat hij het niet weet — niet de laatst bekende groene stand
 * (#202: bij een uitgevallen /api/health bleef "Optimaal" onbeperkt staan).
 */
export function systemStatusView(health: HealthResponse | null, stale: boolean): SystemStatusView {
  if (stale) {
    return { label: '? Onbekend', color: 'var(--text-tertiary)', sub: 'health niet bereikbaar' };
  }
  if (health == null) {
    return { label: '—', color: 'var(--text-tertiary)', sub: null };
  }
  const sub = health.uptime_seconds != null
    ? `Pi up ${Math.round((health.uptime_seconds ?? 0) / 86400)}d`
    : null;
  if (health.status === 'ok') return { label: '✓ Optimaal', color: '#16a34a', sub };
  return { label: '⚠ Aandacht', color: '#d97706', sub };
}
